import { useSelector } from 'react-redux'

/**
 * Custom hook to detect if the video gallery popup is currently open
 * @returns {boolean} true if video gallery popup is open, false otherwise
 */
export const useVideoGalleryPopup = () => {
  const messageBox = useSelector(state => state.messageBox)

  // Check if any message box contains a VideoGallery component
  const isVideoGalleryOpen = messageBox.contents.some(content => {
    if (!content.component) return false

    // Check if the component is VideoGallery by looking at the component type
    const componentType = content.component.type
    const isVideoGalleryComponent =
      componentType?.name === 'VideoGallery' ||
      componentType?.displayName === 'VideoGallery' ||
      componentType?.displayName === 'withStyles(VideoGallery)'

    // Check if the component has video gallery specific props
    const hasVideoProps =
      content.component.props &&
      (content.component.props.popupType === 'video' ||
        content.component.props.filterType === 'video')

    // Check if the title indicates it's a media gallery (common pattern)
    const hasMediaGalleryTitle =
      content.title && content.title.includes('Media Gallery')

    const result =
      isVideoGalleryComponent || hasVideoProps || hasMediaGalleryTitle

    return result
  })

  return isVideoGalleryOpen
}
